import { useMemo } from 'react';
import _isNil from 'lodash/isNil';
import { Candidate } from '../../../../firebase/firestore/documents/candidate';
import { Query } from '../../../../firebase/firestore/query/query';
import { useCurrentUserProfile } from '../../../../app/hooks/useCurrentUserProfile';
import { Collections } from '../../../../firebase/firestore/collections';
import { useQueryOnce } from '../../../../firebase/firestore/hooks';
import { useStoreState } from '../../../../models/hooks';
import { checkIfUserRestrictedInPositions, filteredCandidatesByRestriction } from '../../../../services/userService';

export const useSeekerAllCandidates = (seekerId?: string): Readonly<Candidate>[] | undefined => {
  const { currentUserProfile } = useCurrentUserProfile();
  const appOwnersId = useStoreState((s) => s.app.accounts?.owners);
  const appUserId = useStoreState((s) => s.app.user?.id);
  const accounts = useStoreState((s) => s.app.accounts);
  const restrictPositions = useStoreState((s) => s.app.user?.restrictPositions);

  const superOwners = accounts?.superOwners ?? [];

  const isUserRestrictedInPositions = checkIfUserRestrictedInPositions({
    appOwnersId,
    appUserId,
    superOwners,
    isUserRestricted: restrictPositions,
  });

  const candidates = useQueryOnce<Readonly<Candidate>>(Collections.CANDIDATES, [
    Query.field<Candidate>('seeker').equals(seekerId),
    Query.field<Candidate>('account').equals(currentUserProfile?.account),
    Query.field<Candidate>('positionOpen').equals(true),
  ]);

  return useMemo(() => {
    if (!currentUserProfile || _isNil(candidates)) {
      return undefined;
    }

    return filteredCandidatesByRestriction(candidates as Candidate[], isUserRestrictedInPositions, appUserId);
  }, [candidates, currentUserProfile, isUserRestrictedInPositions, appUserId]);
};
